/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminCreateProductOrder,
    AdminCreateProductOrderFromJSON,
    AdminCreateProductOrderToJSON,
    AdminOrderStatus,
    AdminOrderStatusFromJSON,
    AdminOrderStatusToJSON,
    AdminProductOrdersResp,
    AdminProductOrdersRespFromJSON,
    AdminProductOrdersRespToJSON,
} from '../models';

export interface AdminOrdersApiAdminCreateProductOrderRequest {
    id: string;
    params: AdminCreateProductOrder;
}

export interface AdminOrdersApiAdminGetOrdersByProductIDRequest {
    id: string;
}

export interface AdminOrdersApiAdminUpdateOrderStatusRequest {
    id: string;
    orderId: string;
    params: AdminOrderStatus;
}

export function createAdminCreateProductOrderPath(id: string): string {
    return `/admin/products/{id}/orders`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminCreateProductOrderFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/orders`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminGetOrdersByProductIDPath(id: string): string {
    return `/admin/products/{id}/orders`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminGetOrdersByProductIDFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/orders`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminUpdateOrderStatusPath(id: string, orderId: string): string {
    return `/admin/products/{id}/orders/{order_id}/status`
        .replace(`{${'id'}}`, encodeURIComponent(id))
        .replace(`{${'order_id'}}`, encodeURIComponent(orderId));
}
export function createAdminUpdateOrderStatusFullPath(id: string, orderId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{id}/orders/{order_id}/status`
            .replace(`{${'id'}}`, encodeURIComponent(id))
            .replace(`{${'order_id'}}`, encodeURIComponent(orderId))
    );
}

/**
 *
 */
export class AdminOrdersApi extends runtime.BaseAPI {
    /**
     * Create product order
     * Create product order
     */
    async adminCreateProductOrder(
        requestParameters: AdminOrdersApiAdminCreateProductOrderRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminCreateProductOrder.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminCreateProductOrder.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminCreateProductOrderPath(String(requestParameters?.id)),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminCreateProductOrderToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Get orders by product ID
     * Get orders by product ID
     */
    async adminGetOrdersByProductID(
        requestParameters: AdminOrdersApiAdminGetOrdersByProductIDRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductOrdersResp>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminGetOrdersByProductID.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminGetOrdersByProductIDPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminProductOrdersRespFromJSON(jsonValue))
        );
    }
    /**
     * Update order status
     * Update order status
     */
    async adminUpdateOrderStatus(
        requestParameters: AdminOrdersApiAdminUpdateOrderStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminUpdateOrderStatus.'
            );
        }

        if (requestParameters?.orderId === null || requestParameters?.orderId === undefined) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter requestParameters.orderId was null or undefined when calling adminUpdateOrderStatus.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminUpdateOrderStatus.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminUpdateOrderStatusPath(
                        String(requestParameters?.id),
                        String(requestParameters?.orderId)
                    ),
                    method: 'PUT',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminOrderStatusToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
}
